'use client';

import { queryOptions } from '@tanstack/react-query';

import { browserApiRequest } from '@/shared/api';

import { ProductListSchema } from '../model/product';

/** Product cards by slug (recently viewed, variant choice in the cart); the API returns them in the given order. */
export function productCardsQueryOptions(slugs: readonly string[]) {
  const list = slugs.join(',');
  return queryOptions({
    queryKey: ['catalog', 'cards', list],
    queryFn: ({ signal }) =>
      browserApiRequest(`/api/catalog?slugs=${encodeURIComponent(list)}`, ProductListSchema, {
        signal,
      }),
    staleTime: 60_000,
  });
}
